import React from 'react'
import './index.css'
import {
 
  Input,
  Icon,
  Button,
  Form,
 Modal,
  message,
  Spin
} from 'antd'
import request from '@/utils/request'
// import Cookies from 'js-cookie' // js-cookie
import { setKey, getKey } from '@/utils/Cookie'
import axios from 'axios'
import PersonImg from '@/img/person.png'
import showImg from '@/img/showGo.png'
import moment from 'moment'
import scanCoder from '@/img/scanCoder.jpg'
const FormItem = Form.Item
var myCaptchaPerson = null
class LoginForm extends React.Component {
  state = {
    IndexKey: null, //当前天数索引值
    currentIndex: null, //选择样式
    visible: false, //显示新增预约
    tid: null, //选择日期
    TimeArray: [], //时间
    TimeArrayData: [], //时间票数
    OrderList: [], //我的订单数据
    key:null,
    picShow: null,
    picFile: null,

    UnSendArrayList: [],
    facilityMarking: null,
    optionData: null,
    showtime: null,
    submitState: false,
    isVilLoading:false,
    dataObjContent:null,
    imgId:null,
  }
  componentDidMount() {
   
  }
  componentWillMount() {
  }

  getDataInfo(){
    var that = this
    request
    .get('/v1/news?code=1')
    .then(res => {
       console.log('res')
      // console.log(res)
      // console.log(this.state.TimeArray)
      const data = res
      // for (var i = 0; i < this.state.IndexKey; i++) {
      //   ArrayData.unshift({})
      // }
      // console.log(ArrayData)
      console.log(data)
      this.setState({
        dataObjContent: data
      })
    })
  }
  //确定预约
  sendData() {
    // console.log(this.state.UnSendArrayList)
    console.log(this.imgId)
    if (this.state.UnSendArrayList && this.state.UnSendArrayList.length > 0) {
      let formData = new FormData()
      this.state.UnSendArrayList.map((item, index) => {
        // console.log(item.file)
        formData.append(`idCard_${index}`, item.idCard)
        formData.append(`name_${index}`, item.name)
        formData.append(`facilityMarking_${index}`, item.facilityMarking)
        formData.append(`tid_${index}`, item.tid)
        formData.append(`pic_${index}`, item.file)
        
      })
      formData.append(`imgId`, this.imgId)
      // console.log(formData)
      myCaptchaPerson.reload()
      myCaptchaPerson.show()
      this.setState({
        optionData: formData
      })
      // let config = {
      //   headers: {
      //     'Content-Type': 'multipart/form-data'
      //   }
      // }
      // axios.post('/v1/mobile/reserve/personal', formData, config).then(res => {
      //   console.log('个人预约')
      //   console.log(res)
      //   if (res.message == '预约成功！') {
      //     this.props.history.push('/Main/Home/ShowAppointment')
      //   } else {
      //     // Cookies.set('MessageFiald', JSON.stringify(res))
      //     setKey('MessageFiald', JSON.stringify(res))
      //     this.props.history.push('/Main/Home/ShowAppointmentFaild')
      //   }
      // })
    } else {
      message.info('请先添加预约人！')
    }
  }
  //添加预约
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      // console.log(values)
      // console.log(this.state.picFile)
      // console.log(this.state.facilityMarking)
      if (!err) {
        let formData = new FormData()
        formData.append("key",values.key)
        var that = this
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
        request
        .post('/v1/user/keyLogin',formData,config)
        .then(res => {
          if(res.code== 0){
            console.log('res')
            // console.log(res)
            // console.log(this.state.TimeArray)
            const data = res
            // for (var i = 0; i < this.state.IndexKey; i++) {
            //   ArrayData.unshift({})
            // }
            // console.log(ArrayData)
            console.log(data)
            setKey('facilityMarking',res.data)
            setKey('SCMT-ADMIN-TOKEN',res.token)
            this.props.form.resetFields()
            that.props.history.push('/Main/Home/Instructions')
          }else{
            message.warning(
              res.msg
            )
          }

        })        
        // console.log('Received values of form: ', values)
        // console.log(values)
        
      }
    })
  }
  //提示未选择时间
  warning() {
    Modal.warning({
      title: '提示',
      content: '请先选择预约具体时间！'
    })
  }

  handlePreview() {}
  handleChange() {}
 
 
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 20 },
        sm: { span: 10 }
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 5 }
      }
    }
    const prefixSelector = getFieldDecorator('prefix', {
      initialValue: '86'
    })
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0
        },
        sm: {
          span: 24,
          offset: 0
        }
      }
    }
    const {
      IndexKey,
      TimeArrayData,
      currentIndex,
      UnSendArrayList,
      dataObjContent
    } = this.state
    // console.log('UnSendArrayList')
    // console.log(UnSendArrayList)
    return (
      <div className="instructions">
      <div className="instructions_name"> 请在“四川科技馆”微信公众号，参观预约界面中获取“预约密钥”</div>
      <div><img src={scanCoder} ></img></div>
        <Spin tip="资料正在上传请耐心等待..." spinning={this.state.submitState}>
        <Form {...formItemLayout} onSubmit={this.handleSubmit} >
              <Form.Item label={<span>登录码</span>}>
                {getFieldDecorator('key', {
                  rules: [
                    {
                      required: true,
                      message: '请输入登录码',
                      whitespace: true
                    }
                  ]
                })(<Input placeholder="请输入登录码" />)}
              </Form.Item>
              <Form.Item {...tailFormItemLayout}>
                {/* <Button type="primary" htmlType="submit">
                立即预约
              </Button> */}
                <div className="TeamAppointment_footer">
                  <Button
                    className="TeamAppointment_footer_button"
                 //    onClick={el => this.login()}
                    htmlType="submit"
                  >
                     立即登录
                  </Button>
                </div>
              </Form.Item>
            </Form>
          <div className="ccc">
            <div id="c1" ref="myInput"></div>
          </div>
          <div className="instructions_content_row" dangerouslySetInnerHTML={{__html:dataObjContent}}>
          </div>

      
        </Spin>
      </div>
    )
  }
}
const Login = Form.create()(LoginForm)
export default Login
